import react, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

// Redux Actions
import { sendUserReport } from '../../redux/modules/reports';

// Twine Components
import ReportUser from '../Portfolio/ReportUser';

const ReportUserModal = ({
  claimant,
  accusedUser,
  isBrief,
  onClose,
  brief,
}) => {
  const dispatch = useDispatch();
  const [reportComments, setReportComments] = useState('example');
  const [reportReason, setReportReason] = useState('Spam');

  const resetFields = () => {
    setReportComments('');
    setReportReason('Spam');
  };

  const handleReport = (user, reason, comments) => {
    dispatch(sendUserReport(user, reason, comments));
    resetFields();
    onClose();
  };

  const prefillReport = () => {
    const commentString = `${claimant?.displayname} is reporting ${accusedUser?.displayname} for the following brief: ${brief.links.main}`;
    setReportComments(commentString);
  };

  useEffect(() => {
    console.log(brief);
    if (isBrief) {
      prefillReport();
    }
  }, [isBrief]);

  return (
    <ReportUser
      onChangeReportComments={(comments) => setReportComments(comments)}
      onChangeReportReason={(reason) => setReportReason(reason)}
      onReport={() => handleReport(accusedUser, reportReason, reportComments)}
      reportComments={reportComments}
      reportReason={reportReason}
      user={accusedUser}
    />
  );
};

export default ReportUserModal;

ReportUserModal.propTypes = {
  claimant: PropTypes.object,
  accusedUser: PropTypes.object,
  isBrief: PropTypes.bool,
  onClose: PropTypes.func,
};
